module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJ0lEQVQImW3KsREAIBDDMIVhfyiWDQUdhysVDgbablie0vYime9xAFJvB2oasN26AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/pattern.png
// module id = 720
// module chunks = 0 1 2 3 4